
// Pages
import { Route, Routes } from "react-router-dom";
import Main from "./Main";
import ProtectedRoute from "./ProtectedRoute";
import AddNewBlog from "./pages/Blogs/AddNewBlog";
import AllBlogs from "./pages/Blogs/AllBlogs";
import BlogCategories from "./pages/Blogs/BlogCategories";
import EditBlog from "./pages/Blogs/EditBlog";
import ViewBlog from "./pages/Blogs/ViewBlog";
import Dashboard from "./pages/Dashboard/Dashboard";
import Login from "./pages/Login/Login";
import Logout from "./pages/Logout";
import NotFoundPage from "./pages/NotFound/NotFoundPage";
import AddPushNotification from "./pages/Notifications/AddPushNotification";
import PushNotifications from "./pages/Notifications/PushNotifications";
import AllOrders from "./pages/Orders/AllOrders";
import Cities from "./pages/Orders/Cities";
import OrderDetails from "./pages/Orders/OrderDetails";
import OrderInvoice from "./pages/Orders/OrderInvoice";
import Reviews from "./pages/Orders/Reviews";
import ShippingCharges from "./pages/Orders/ShippingCharges";
import UpdateCity from "./pages/Orders/UpdateCity";
import UpdateShippingCharges from "./pages/Orders/UpdateShippingCharges";
import AddProduct from "./pages/Products/AddProduct";
import AddProductCategory from "./pages/Products/AddProductCategory";
import AddProductSubcategory from "./pages/Products/AddProductSubcategory";
import AllProducts from "./pages/Products/AllProducts";
import BannerSlider from "./pages/Products/BannerSlider";
import ProductPromotions from "./pages/Products/ProductPromotions";
import ProductsCategory from "./pages/Products/ProductsCategory";
import ProductsSubCategories from "./pages/Products/ProductsSubCategories";
import UpdateBannerSlider from "./pages/Products/UpdateBannerSlider";
import UpdateProduct from "./pages/Products/UpdateProduct";
import UpdateProductCategory from "./pages/Products/UpdateProductCategory";
import UpdateProductPromotions from "./pages/Products/UpdateProductPromotions";
import UpdateProductSubcategory from "./pages/Products/UpdateProductSubcategory";
import UpdateProductVariant from "./pages/Products/UpdateProductVariant";
import UpdatePromotion from "./pages/Products/UpdatePromotion";
import PromoCodes from "./pages/PromoCodes";
import ReferralUsers from "./pages/ReferralUsers";
import AssignRoles from "./pages/RolesManagement/AssignRoles";
import Roles from "./pages/RolesManagement/Roles";
import UpdateRole from "./pages/RolesManagement/UpdateRole";
import Sitemap from "./pages/Sitemap";
import UpdatePromoCode from "./pages/UpdatePromoCode";
import UpdateSitemap from "./pages/UpdateSitemap";
import Users from "./pages/Users/Users";

const AllRouting = () => {
  return (
    <Routes>
      <Route element={<ProtectedRoute />}>
        <Route path="/" element={<Main />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="sitemap" element={<Sitemap />} />
          <Route path="update-sitemap/:s_id" element={<UpdateSitemap />} />
          <Route path="roles" element={<Roles />} />
          <Route path="update-role" element={<UpdateRole />} />
          <Route path="assign-roles" element={<AssignRoles />} />
          <Route path="users" element={<Users />} />
          <Route path="products" element={<AllProducts />} />
          <Route path="add-product" element={<AddProduct />} />
          <Route
            path="update-product/:product_id"
            element={<UpdateProduct />}
          />
          <Route
            path="update-variant/:p_v_id"
            element={<UpdateProductVariant />}
          />
          <Route path="products-category" element={<ProductsCategory />} />
          <Route path="add-product-category" element={<AddProductCategory />} />
          <Route
            path="update-product-cat/:p_category_id"
            element={<UpdateProductCategory />}
          />

          <Route path="subcategories" element={<ProductsSubCategories />} />
          <Route
            path="add-product-subcategory"
            element={<AddProductSubcategory />}
          />
          <Route
            path="update-product-subcat/:s_cat_id"
            element={<UpdateProductSubcategory />}
          />
          <Route path="banner-slider" element={<BannerSlider />} />
          <Route path="update-slider/:bs_id" element={<UpdateBannerSlider />} />
          <Route path="product-promotions" element={<ProductPromotions />} />
          <Route
            path="update-product-promo/:"
            element={<UpdateProductPromotions />}
          />
          <Route path="blogs" element={<AllBlogs />} />
          <Route path="view-blog/:b_id" element={<ViewBlog />} />
          <Route path="edit-blog/:b_id" element={<EditBlog />} />
          <Route path="new-blog" element={<AddNewBlog />} />
          <Route path="blog-categories" element={<BlogCategories />} />
          <Route path="push-notifications" element={<PushNotifications />} />
          <Route path="add-notification" element={<AddPushNotification />} />
          <Route path="orders" element={<AllOrders />} />
          <Route path="order-details/:order_id" element={<OrderDetails />} />
          <Route path="order-invoice/:order_id" element={<OrderInvoice />} />
          <Route path="cities" element={<Cities />} />
          <Route path="update-city/:city_id" element={<UpdateCity />} />
          <Route path="shipping-charges" element={<ShippingCharges />} />
          <Route
            path="update-shipping-charges/:wc_id"
            element={<UpdateShippingCharges />}
          />
          <Route path="reviews" element={<Reviews />} />
          <Route path="promo-codes" element={<PromoCodes />} />
          <Route
            path="update-product-promo/:pi_id"
            element={<UpdatePromotion />}
          />
          <Route
            path="update-promo-codes/:pc_id"
            element={<UpdatePromoCode />}
          />
          <Route path="referral-users" element={<ReferralUsers />} />

          <Route path="logout" element={<Logout />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Route>
      <Route path="/login" element={<Login />} />
    </Routes>
  );
};

export default AllRouting;
